import React, { useEffect, useState } from 'react';
import gamePopupService, { GamePopupData } from '../services/gamePopupService';
import './GamePopup.css';

interface GamePopupProps {
  className?: string;
  style?: React.CSSProperties;
}

const GamePopup: React.FC<GamePopupProps> = ({ className = '', style = {} }) => {
  const [currentPopup, setCurrentPopup] = useState<GamePopupData | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleUpdate = () => {
      const popup = gamePopupService.getCurrentPopup();
      setCurrentPopup(popup);
      setIsVisible(!!popup);
    };

    const unsubscribe = gamePopupService.subscribe(handleUpdate);
    
    // Initial sync
    handleUpdate(); 

    return () => unsubscribe();
  }, []);

  const handleAction = () => {
    if (currentPopup?.onAction) {
      currentPopup.onAction();
    }
    gamePopupService.dismissCurrentPopup();
  };

  const handleDismiss = () => {
    if (currentPopup?.dismissible !== false) {
      gamePopupService.dismissCurrentPopup();
    }
  };

  if (!currentPopup) {
    console.log('GamePopup rendering null - no currentPopup');
    return null;
  }

  console.log('GamePopup rendering popup:', currentPopup.id, 'visible:', isVisible);

  const getPopupIcon = () => {
    if (currentPopup.icon) {
      return currentPopup.icon;
    }

    switch (currentPopup.type) {
      case 'welcome':
        return '👋';
      case 'checkin':
        return '📅';
      case 'energy':
        return '⚡';
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'top10':
        return '🏆';
      default:
        return 'ℹ️';
    }
  };

  const getPopupClass = () => {
    let baseClass = 'game-popup';
    if (currentPopup.type) {
      baseClass += ` game-popup--${currentPopup.type}`;
    }
    if (isVisible) {
      baseClass += ' game-popup--visible';
    }
    if (className) {
      baseClass += ` ${className}`;
    }
    return baseClass;
  };

  return (
    <div className="game-popup-overlay" style={style}>
      <div className={getPopupClass()}>
        <div className="game-popup__content">
          {/* Icon */}
          <div className="game-popup__icon">
            {getPopupIcon()}
          </div>

          {/* Title */}
          {currentPopup.title && (
            <h3 className="game-popup__title">
              {currentPopup.title}
            </h3>
          )}

          {/* Message */}
          <p className="game-popup__message">
            {currentPopup.message}
          </p>

          {/* Actions */}
          <div className="game-popup__actions">
            {currentPopup.actionText && (
              <button 
                className="game-popup__action-btn game-popup__action-btn--primary"
                onClick={handleAction}
              >
                {currentPopup.actionText}
              </button>
            )}
            
            {currentPopup.dismissible !== false && (
              <button 
                className="game-popup__action-btn game-popup__action-btn--secondary"
                onClick={handleDismiss}
              >
                {currentPopup.actionText ? 'Để sau' : 'Đóng'}
              </button>
            )}
          </div>
        </div>

        {/* Close button */}
        {currentPopup.dismissible !== false && (
          <button 
            className="game-popup__close-btn"
            onClick={handleDismiss}
            aria-label="Đóng"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default GamePopup;